import Model from "../Model";
import JobInterface from "./JobInterface";
export default class Job extends Model {
}
